import { useLocation, useNavigate } from "react-router-dom";
import Header from "../header";
import Router from "../../../routes";
import { useEffect, useState } from "react";
import Footer from "../footer";
import RequestCallBackPopUp from "../../../components/requestCallBack/popUp";
import GlobalErrorBoundary from "../../../components/error/globalErrorBoundary";
import { unlockBodyScroll } from "../../../utility/utils";

function MainLayout() {
    const location = useLocation();
    const navigate = useNavigate();
    const [showLogin, setShowLogin] = useState(false);
    const [globalSearchPopup, setGlobalSearchPopup] = useState(false);
    const [requestCallBackPopup, setRequestCallBackPopup] = useState(false);

    const handleNavFunc = async (redirectTo: any) => {
        navigate(redirectTo);
    };

    //#region Request CallBack Popup — home page only
    useEffect(() => {
        setRequestCallBackPopup(false);
        unlockBodyScroll();

        if (location.pathname !== "/") return;

        const timeoutId = setTimeout(() => {
            setRequestCallBackPopup(true);
        }, 10000); // 10 seconds

        return () => {
            clearTimeout(timeoutId);
            setRequestCallBackPopup(false);
            unlockBodyScroll();
        };
    }, [location.pathname]);
    //#endregion

    const isBrochureViewer = location.pathname.startsWith("/e-brochure");

    return (
        <>
            {!isBrochureViewer && (
            <Header
                handleNavFunc={handleNavFunc}
                showLogin={showLogin}
                setShowLogin={setShowLogin}
                globalSearchPopup={globalSearchPopup}
                setGlobalSearchPopup={setGlobalSearchPopup}
            />
            )}
            <GlobalErrorBoundary>
                <Router
                    showLogin={showLogin}
                    setShowLogin={setShowLogin}
                />
            </GlobalErrorBoundary>
            {!isBrochureViewer && (
            <Footer
                globalSearchPopup={globalSearchPopup}
                setGlobalSearchPopup={setGlobalSearchPopup}
                onRequestCallback={() => setRequestCallBackPopup(true)}
            />
            )}
            <RequestCallBackPopUp
                showModal={requestCallBackPopup}
                setShowModal={setRequestCallBackPopup}
                tag={location.pathname == "/" ? "home" : location?.pathname}
            />
        </>
    );
}

export default MainLayout;
